export const userActionTypes = {
  SIGN_UP: "SIGN_UP",
  LOG_OUT: "LOG_OUT",
  LOG_IN: "LOG_IN",
  AUTH_ERROR: "AUTH_ERROR",
  SET_CURRENT_USER: "SET_CURRENT_USER",
};
